import { putMethodWithTokenWithLatLng } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_FAILURE = 'UPDATE_CAMPAIGN_FAILURE';

// Action Creators
export const fetchUpdateCampaign = () => ({
  type: UPDATE_CAMPAIGN,
});

export const fetchUpdateCampaignSuccess = (data) => ({
  type: UPDATE_CAMPAIGN_SUCCESS,
  payload: data,
});

export const fetchUpdateCampaignFailure = (error) => ({
  type: UPDATE_CAMPAIGN_FAILURE,
  payload: error,
});

// Thunk Function
export const updateCampaignCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateCampaign(data, external));
    try {
      const response = await putMethodWithTokenWithLatLng(
        url.updateCampaignSuperAdmin + external?.id + '/' + 'update' + '/',
        data,
        external?.latlng
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateCampaignSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateCampaignFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateCampaignFailure(error.message));
    }
  };
};
